/* eslint-disable react/no-array-index-key */

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import MainLayout from 'components/MainLayout'
import { Container } from 'components/layout/Grid/'
import BackToAdminCentre from 'components/BackToAdminCentre'
import RouteWithSubRoutes from 'components/RouteWithSubRoutes'
import { resetErrorMessage, setErrorMessage } from 'actions/app'
import { modalShow, modalHide } from 'actions/modals'
import { getFeatureToggles, editFeatureToggle } from 'actions/featureToggle'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { hasAccess } from 'utils/hasAccess'
import { getEmployeeId } from 'utils/getEmployeeId'

class FeatureToggle extends Component {
  static propTypes = {
    accountsAndLoans: PropTypes.object.isRequired,
    currentUser: PropTypes.object,
    editFeatureToggle: PropTypes.func.isRequired,
    getFeatureToggles: PropTypes.func.isRequired,
    modalHide: PropTypes.func.isRequired,
    modalShow: PropTypes.func.isRequired,
    routes: PropTypes.instanceOf(Array),
    setErrorMessage: PropTypes.func.isRequired,
  }
  static defaultProps = {
    routes: {},
    currentUser: null,
  }
  componentDidMount() {
    hasAccess(this.props.currentUser, 'ADMN: Feature toggle', this.props.history, 'RW', true)
    this.props.getFeatureToggles(getEmployeeId(this.props.selectedPartner, this.props.currentUser))
  }

  handleUpdateFeatureToggle = (data) => {
    const updateItem = {
      ...data,
      employee_id: getEmployeeId(this.props.selectedPartner, this.props.currentUser),
      feature_id: data.feature_id,
      is_enabled: !data.is_enabled,
    }

    if (updateItem) {
      this.props.editFeatureToggle(updateItem)
    }
  }

  bannerProps = () => {
    const {
      routes, history, location, match, path,
    } = this.props
    return {
      name: 'Admin centre',
      history,
      location,
      path,
      match,
      routes,
    }
  }

  render() {
    const {
      routes, featureToggle, currentUser,
    } = this.props

    return (
      <MainLayout bannerNavProps={{ ...this.bannerProps() }} showSidebar={false} sidebarType="partnerSideBar">
        <BackToAdminCentre displayText="Feature toggle" isAdmin={this.props.currentUser.IsAdmin} />
        <Container>
          {routes.map((route, i) => (
            <RouteWithSubRoutes
              key={i}
              {...route}
              currentUser={currentUser}
              editFeatureToggle={this.handleUpdateFeatureToggle}
              featureToggle={featureToggle}
              getFeatureToggles={this.props.getFeatureToggles}
              setErrorMessage={this.props.setErrorMessage}
            />
            ))}
        </Container>
      </MainLayout>
    )
  }
}

const mapStateToProps = state => ({
  errorMessage: state.errorMessage,
  featureToggle: state.featureToggle,
  editFeatureToggle: state.editFeatureToggle,
})

export default withRouter(connect(mapStateToProps, {
  resetErrorMessage,
  setErrorMessage,
  getFeatureToggles,
  editFeatureToggle,
  modalShow,
  modalHide,
})(FeatureToggle))



// WEBPACK FOOTER //
// ./src/containers/FeatureToggle.js